import { Stack, Tooltip, Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { formatNumber } from "util/formatNumber";

import { EMANIFEST_OVERRIDE_EXPLANATION } from "./eManifestAmountOverrideText";

export interface EManifestAmountWithOverrideProps {
  /** Box 11 amount in pounds. */
  eManifestAmount: number | null | undefined;
  /** Staff-confirmed Box 18a amount in pounds, when one replaces Box 11. */
  eManifestAmountOverride: number | null | undefined;
}

/**
 * The e-Manifest amount: Box 11 on its own, or Box 11 followed by the Box 18a
 * override line when staff have confirmed one. The lines wrap instead of
 * truncating, because every grid that renders this uses auto row height.
 */
export function EManifestAmountWithOverride({
  eManifestAmount,
  eManifestAmountOverride,
}: EManifestAmountWithOverrideProps) {
  const box11 = eManifestAmount ? `${formatNumber(eManifestAmount)} lbs` : null;
  if (eManifestAmountOverride == null) {
    return box11 ? <span>{box11}</span> : null;
  }
  return (
    <Tooltip title={EMANIFEST_OVERRIDE_EXPLANATION}>
      <Stack sx={{ lineHeight: 1.25, minWidth: 0 }}>
        {box11 && <Typography variant="body2">{box11} (Box 11)</Typography>}
        <Typography variant="caption" color="text.secondary">
          {formatNumber(eManifestAmountOverride)} lbs Box 18a
        </Typography>
      </Stack>
    </Tooltip>
  );
}

/** DataGrid `renderCell` for an "Amount (e-Manifest)" column. */
export const renderEManifestAmountCell = ({ row }: GridRenderCellParams) => (
  <EManifestAmountWithOverride
    eManifestAmount={row.eManifestAmount}
    eManifestAmountOverride={row.eManifestAmountOverride}
  />
);
